var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-7 -6)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A7D9FF",
    d: "M5.357 9.6c-.29 0-.571-.151-.725-.421-.227-.4-.087-.909.311-1.136l7.733-4.41c.399-.23.909-.088 1.138.312.227.4.087.909-.312 1.136L5.77 9.491c-.131.074-.273.109-.413.109zM13.087 16.475c-.14 0-.281-.035-.411-.11l-7.733-4.409c-.4-.227-.54-.737-.31-1.136.227-.4.735-.541 1.137-.311l7.732 4.409c.4.227.54.737.312 1.136-.155.27-.437.42-.727.42z",
    transform: "translate(7 6)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#579FD7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.386 16.666c0 1.841-1.492 3.334-3.334 3.334-1.84 0-3.333-1.493-3.333-3.334 0-1.84 1.492-3.333 3.333-3.333 1.842 0 3.334 1.492 3.334 3.333zM18.386 3.334c0 1.84-1.492 3.333-3.334 3.333-1.84 0-3.333-1.492-3.333-3.333C11.719 1.493 13.21 0 15.052 0c1.842 0 3.334 1.493 3.334 3.334zM6.719 10c0 1.841-1.493 3.334-3.334 3.334S.051 11.84.051 10s1.493-3.334 3.334-3.334S6.719 8.16 6.719 10z",
    transform: "translate(7 6) translate(.003)"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.a9f8c08b.svg";
export { ForwardRef as ReactComponent };